// extracted by mini-css-extract-plugin
module.exports = {"root":"Link-module--root--1i4d5","active":"Link-module--active--2StDn"};